define('_models/Message',[
	
],
function(
	
) {

	return Backbone.Model.extend({

		initialize: function(){

		},

		url : function() {
			var path =  "/_api/v0/message/";
			path += (this.get('id')) ? this.get('id') : '';
			return path;
		}

	});

});

